// Generated types for DeduplicationTask
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { LLMTaskReadAPI, LLMTaskWriteAPI } from '../../llm_task/types/llmtask';
import { LLMTaskReadAPISchemaObject, LLMTaskWriteAPISchemaObject } from '../../llm_task/types/llmtask';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface DeduplicationTaskReadAPI extends LLMTaskReadAPI {
}

export interface DeduplicationTaskWriteAPI extends LLMTaskWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const DeduplicationTaskReadAPISchema: z.ZodType<DeduplicationTaskReadAPI> = LLMTaskReadAPISchemaObject.extend({}).passthrough();

export const DeduplicationTaskWriteAPISchema: z.ZodType<DeduplicationTaskWriteAPI> = LLMTaskWriteAPISchemaObject.extend({}).passthrough();
